import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { MyCampaignsPage } from "./my-campaigns";
import { ComponentsModule } from "../../components/components.module";

@NgModule({
  declarations: [MyCampaignsPage],
  imports: [IonicPageModule.forChild(MyCampaignsPage), ComponentsModule],
})
export class MyCampaignsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/my-campaigns/my-campaigns.module.ts